import { AppState } from './app';
import { ConsigneeSharedState } from './consignee';
import { DispatchSharedState } from './dispatch';
import { ScheduleSharedState } from './schedule';
import { RetailerSharedState } from './retailers';
import { SelectPartyState } from './party';
import { InventorySharedState } from './inventory';

export const RootStates: any[] = [
	DispatchSharedState,
	ScheduleSharedState,
	AppState,
	RetailerSharedState,
	ConsigneeSharedState,
	SelectPartyState,
	InventorySharedState
]
